module.exports = __webpack_public_path__ + "img/headRight6.dc131f7d.png";